import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import Container from "../../../../base/components/container.js";

const blockStyles = makeStyles(theme => ({
  root: {
    padding: "50px 0",
    background: "white",
    ['@media (max-width: 768px)']: {
      padding: "24px 0 32px"
    }
  },
  container: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  },
}));

const PageContainer = (props) => {
  const classes = blockStyles();
  
  const { className, children } = props;
  return (
    <div className = { clsx(classes.root, className) }>
      <Container className = { classes.container } >
        { children }
      </Container>
    </div>
  );
};

export default PageContainer;